import { FaPlus, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import localeInfo from "rc-pagination/lib/locale/en_US";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
  Modal,
  FormGroup,
} from "react-bootstrap";
import Swal from "sweetalert2";
import { useGetRoleQuery } from "../../redux/api";
import { useListTeamMembersQuery, useGetTeamMemberQuery, useCreateTeamMemberMutation, useEditTeamMemberMutation, useDeleteTeamMemberMutation } from "../../redux/api";
import { ENV } from "../../config/config";
import { toast } from "react-toastify";

var CryptoJS = require("crypto-js");
import Select from "react-select";

const TeamMembersListing = (props) => {
  const [qs, setQs] = useState("");
  const { data: listData, isLoading: isListLoading, isFetching: isListFetching, refetch } = useListTeamMembersQuery(qs);
  const [selectedId, setSelectedId] = useState(null);
  const { data: memberData } = useGetTeamMemberQuery(selectedId, { skip: !selectedId });
  const [createMember, { isLoading: isCreatingMember }] = useCreateTeamMemberMutation();
  const [editMember, { isLoading: isUpdatingMember }] = useEditTeamMemberMutation();
  const [deleteMember, { isLoading: isDeletingMember }] = useDeleteTeamMemberMutation();

  const [teamMembers, setTeamMembers] = useState(null);
  const [teamMember, setTeamMember] = useState({
    fullName: "",
    designation: "",
    memberType: "",
    image: "",
    x: "",
    linkedIn: "",
    facebook: "",
    isActive: true,
  });
  const [categoryOptions, setOptions] = useState([]);
  const [imageFlag, setImageFlag] = useState(false);
  const [image, setImage] = useState(false);
  const [pagination, setPagination] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [resetButton, setResetButton] = useState(false);
  const [filters, setFilters] = useState({
    fullName: "",
    designation: "",
    isActive: "",
  });
  const [modalType, setModalType] = useState(0); // 1 = add, 2 = edit
  const [openModal, setOpenModal] = useState(false);
  const [errors, setErrors] = useState({
    fullName: "",
    image: "",
    memberType: "",
    designation: "",
  });
  const errorSelector = useSelector((state) => state.error);
  // const rolesSelector = useSelector((state) => state.role.getRoleRes); // Migrated to RTK Query
  // const teamSelector = useSelector((state) => state.team);
  const statusOptions = [
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ];
  const memberOptions = [
    { value: "staff", label: "Staff" },
    { value: "board", label: "Board" },
  ];

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    // error handling remains the same; loader is derived from RTK states
  }, [errorSelector.error]);

  const roleEncrypted = localStorage.getItem("role");
  const roleDecrypted = roleEncrypted
    ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
        CryptoJS.enc.Utf8
      )
    : "";
  const { data: roleData } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

  useEffect(() => {
    if (roleData && roleData.role?.permissions) {
      if (typeof roleData.role.permissions === 'string') {
        setPermissions(JSON.parse(roleData.role.permissions));
      } else {
        setPermissions(roleData.role.permissions);
      }
    }
  }, [roleData]);

  useEffect(() => {
    if (listData) {
      const team = listData.team ?? listData.data ?? listData;
      const pag = listData.pagination ?? null;
      setTeamMembers(team);
      setPagination(pag);
    }
  }, [listData]);

  useEffect(() => {
    if (memberData && selectedId) {
      const tm = memberData.team ?? memberData;
      setTeamMember(tm);
      setImage(tm.image ? ENV.galleryPath + tm.image : null);
    }
  }, [memberData, selectedId]);

  useEffect(() => {
    if (!isListLoading && qs) {
      refetch();
    }
  }, [isListLoading]);

  const deleteTeamMemberHandler = (id) => {
    Swal.fire({
      title: "Are you sure you want to delete?",
      html: "If you delete an item, it will lost permanently.",
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: "var(--accent-primary)",
      cancelButtonColor: "var(--accent-danger)",
      confirmButtonText: "Delete",
    }).then(async (result) => {
      if (result.value) {
        (async () => {
          await deleteMember(id);
        })();
      }
    });
  };

  const onPageChange = async (page) => {
    const queryString = ENV.objectToQueryString({ page, ...filters });
    setQs(queryString);
  };

  const applyFilters = () => {
    if (
      filters &&
      (filters.fullName || filters.designation || filters.isActive)
    ) {
      setResetButton(true);
      const queryString = ENV.objectToQueryString({ page: 1, limit: 10, ...filters });
      setQs(queryString);
    } else {
      toast.error("All filter fields are empty", {
        toastId: "FIELD_REQUIRED",
      });
    }
  };

  const reset = () => {
    setResetButton(false);
    setFilters({ fullName: "", designation: "", isActive: "" });
    setQs("");
  };

  const submit = () => {
    let fullNameErr = "";
    let designationErr = "";
    let imgErr = "";
    let memberTypeErr = "";
    let msg = "This field is required";

    if (!teamMember.fullName) fullNameErr = msg;

    if (!teamMember.designation) designationErr = msg;

    if (!teamMember.memberType) memberTypeErr = msg;

    setErrors({
      fullName: fullNameErr,
      designation: designationErr,
      image: imgErr,
      memberType: memberTypeErr,
    });

    if (fullNameErr || designationErr || memberTypeErr) return;

    let formData = new FormData();
    for (const key in teamMember) formData.append(key, teamMember[key]);

    setModalType(0);
    (async () => {
      if (modalType === 2) {
        await createMember(formData);
      } else {
        await editMember(formData);
      }
    })();
  };

  const modalCloseHandler = () => {
    setOpenModal(!openModal);
    setSelectedId(null);
    resetModalContent();
    setModalType(0);
  };

  const resetModalContent = () => {
    setTeamMember({
      fullName: "",
      designation: "",
      image: "",
      x: "",
      linkedIn: "",
      facebook: "",
      isActive: true,
    });
    setImage("");
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const acceptedExtensions = [".jpg", ".jpeg", ".png"];
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();
      if (!acceptedExtensions.includes(fileExtension)) {
        setErrors({
          ...error,
          image:
            "Invalid file extension.\nValid file extentions are: jpg, jpeg and png",
        });
        e.target.value = null; // Deselect the file
        setImage(null); // Clear the image state
        setTeamMember({ ...teamMember, image: null });
      } else {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let result = e.target.result;
          setImage(result);
          setTeamMember({ ...teamMember, image: file });
        };
      }
    }
  };

  const isGlobalLoading = isListLoading || isListFetching || isCreatingMember || isUpdatingMember || isDeletingMember;

  if (isGlobalLoading) {
    return <FullPageLoader />;
  }

  return (
    <>
        <Container fluid>
          <Row className="pb-3">
            <Col sm={12}>
              <Card className="filter-card">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Filters</Card.Title>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>Search with full name...</label>
                        <Form.Control
                          value={filters.fullName}
                          type="text"
                          placeholder="Enter name..."
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              fullName: e.target.value.trim(),
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6}>
                      <Form.Group>
                        <label>Search with designation...</label>
                        <Form.Control
                          value={filters.designation}
                          type="text"
                          placeholder="Enter designation..."
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              designation: e.target.value.trim(),
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} sm={6} className="search-wrap">
                      <label>Search with status...</label>
                      <Form.Group>
                        <Select
                          classNamePrefix="triage-select"
                          placeholder="Select Status"
                          name="status"
                          options={statusOptions}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              isActive: e ? e.value : "",
                            })
                          }
                          value={statusOptions.filter(
                            (l) => l.value === filters.isActive
                          )}
                          isClearable
                        />
                      </Form.Group>
                    </Col>
                    <Col xl={4} md={6}>
                      <Form.Group>
                        <Form.Label className="d-block mb-2">&nbsp;</Form.Label>
                        <div className="d-flex  filter-btns-holder">
                          <Button
                            className="btn-filled mr-3"
                            onClick={applyFilters}
                          >
                            Search
                          </Button>
                          {resetButton && (
                            <Button
                              variant="warning"
                              className="outline-button"
                              onClick={reset}
                            >
                              Reset
                            </Button>
                          )}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Card className="table-big-boy">
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between table-head">
                    <Card.Title as="h4">Team Members</Card.Title>
                    {permissions && permissions.addTeamMember && (
                      <Button
                        className="float-sm-right btn-filled d-flex align-items-center"
                        onClick={() => {
                          resetModalContent();
                          setModalType(2);
                          setOpenModal(true);
                        }}
                      >
                        <span className="add-icon mr-2">
                          <FaPlus />
                        </span>
                        Add Member
                      </Button>
                    )}
                  </div>
                </Card.Header>
                <Card.Body className="table-full-width">
                  <div className="table-responsive">
                    <Table className="table-bigboy table-w">
                      <thead>
                        <tr>
                          <th className="td-start serial-col">#</th>
                          <th className="td-name">
                            <div>Image</div>
                          </th>
                          <th className="td-name">
                            <div className="faqs-title td-name">Full Name</div>
                          </th>
                          <th className="td-name">
                            <div className="faqs-title td-name">
                              Member Type
                            </div>
                          </th>
                          <th className="td-name">
                            <div className="faqs-title td-name">
                              Designation
                            </div>
                          </th>
                          <th className="td-name">
                            <div className="faqs-title td-name">Status</div>
                          </th>
                          <th className="td-actions text-center">
                            <div className="faqs-title">Actions</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {teamMembers && teamMembers.length ? (
                          teamMembers.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="serial-col">
                                  {pagination &&
                                    pagination.limit * pagination.page -
                                      pagination.limit +
                                      index +
                                      1}
                                </td>
                                <td>
                                  <div className="logo-holder d-inline-block align-top">
                                    <img
                                      src={ENV.galleryPath + item.image}
                                      className="user-image"
                                      alt="cover"
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="faq-title td-name">
                                    {item.fullName}
                                  </div>
                                </td>
                                <td>
                                  <div className="faq-title td-name">
                                    {item.memberType}
                                  </div>
                                </td>
                                <td>
                                  <div className="faq-title td-name">
                                    {item.designation}
                                  </div>
                                </td>
                                <td className="td-type">
                                  {" "}
                                  {item.isActive ? (
                                    <span className="label label-success m-0">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="label label-danger m-0">
                                      Inactive
                                    </span>
                                  )}{" "}
                                </td>

                                {(permissions?.viewTeamMember ||
                                  permissions?.editTeamMember ||
                                  permissions?.deleteTeamMember) && (
                                  <td className="td-actions">
                                    <ul className="list-unstyled mb-0 d-flex justify-content-center align-items-center">
                                      {permissions?.viewTeamMember && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                {" "}
                                                View{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="primary"
                                              onClick={() => {
                                                setSelectedId(item.id);
                                                setModalType(1);
                                                setOpenModal(true);
                                              }}
                                            >
                                              <FaEye />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                      {permissions?.editTeamMember && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-436082023">
                                                {" "}
                                                Edit{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="success"
                                              onClick={() => {
                                                setSelectedId(item.id);
                                                setTeamMember(item);
                                                setImage(ENV.galleryPath + item.image);
                                                setModalType(3);
                                                setOpenModal(true);
                                              }}
                                            >
                                              <FaEdit />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                      {permissions?.deleteTeamMember && (
                                        <li className="d-inline-block align-top">
                                          <OverlayTrigger
                                            overlay={
                                              <Tooltip id="tooltip-334669391">
                                                {" "}
                                                Delete{" "}
                                              </Tooltip>
                                            }
                                            placement="left"
                                          >
                                            <Button
                                              className="btn-link btn-icon"
                                              type="button"
                                              variant="danger"
                                              onClick={() =>
                                                deleteTeamMemberHandler(item.id)
                                              }
                                            >
                                              <FaTrash />
                                            </Button>
                                          </OverlayTrigger>
                                        </li>
                                      )}
                                    </ul>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              <div className="alert alert-info" role="alert">
                                No Member Found
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                    {pagination && (
                      <Pagination
                        className="m-3"
                        defaultCurrent={1}
                        pageSize // items per page
                        current={pagination.page} // current active page
                        total={pagination.pages} // total pages
                        onChange={onPageChange}
                        locale={localeInfo}
                      />
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {modalType > 0 && teamMember && (
            <Modal
              className="modal-primary edit-cotnact-modal"
              onHide={modalCloseHandler}
              show={openModal}
            >
              <Modal.Header className="justify-content-center">
                <Row>
                  <div className="col-12">
                    <h4 className="mb-0 mb-md-3 mt-0">
                      {modalType === 1
                        ? "View"
                        : modalType === 2
                        ? "Add"
                        : modalType === 3
                        ? "Edit"
                        : ""}{" "}
                      Member
                    </h4>
                  </div>
                </Row>
              </Modal.Header>
              <Modal.Body>
                <Form className="text-left">
                  {(modalType === 2 || modalType === 3) && (
                    <Form.Group>
                      <label>
                        Image
                      </label>
                      <Form.Control
                        placeholder="Image"
                        type="file"
                        varient="info"
                        accept=".png,.jpeg,.jpg"
                        onChange={(e) => {
                          onFileChange(e);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            image: "",
                          }));
                        }}
                        id="image"
                      ></Form.Control>
                      <span className={errors && errors.image ? `` : `d-none`}>
                        <label>
                          {errors && errors.image ? errors.image : ""}
                        </label>
                      </span>
                    </Form.Group>
                  )}
                  {image && (
                    <Form.Group>
                      <img
                        src={image}
                        id="imageUploader"
                        className="image-fluid"
                        style={{ width: "30%", height: "30%" }}
                        alt="teamMember-image"
                      />
                    </Form.Group>
                  )}
                  <Form.Group>
                    <label>
                      Full Name <span>*</span>
                    </label>
                    <Form.Control
                      className={errors.fullName ? `on-error` : ``}
                      placeholder="Enter Name"
                      type="text"
                      name="name"
                      onChange={(e) => {
                        setTeamMember({
                          ...teamMember,
                          fullName: e.target.value,
                        });
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          fullName: "",
                        }));
                      }}
                      value={teamMember.fullName}
                      required
                      disabled={modalType === 1}
                    />
                    <span className={errors && errors.fullName ? `` : `d-none`}>
                      <label className="pl-1">
                        {errors && errors.fullName ? errors.fullName : ""}
                      </label>
                    </span>
                  </Form.Group>
                  <Form.Group>
                    <label>
                      Designation <span>*</span>
                    </label>
                    <Form.Control
                      className={errors.designation ? `on-error` : ``}
                      placeholder="Enter designation"
                      type="text"
                      name="designation"
                      onChange={(e) => {
                        setTeamMember({
                          ...teamMember,
                          designation: e.target.value,
                        });
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          memberType: "",
                        }));
                      }}
                      value={teamMember.designation}
                      disabled={modalType === 1}
                      required
                    />
                    <span
                      className={errors && errors.designation ? `` : `d-none`}
                    >
                      <label className="pl-1">
                        {errors && errors.designation ? errors.designation : ""}
                      </label>
                    </span>
                  </Form.Group>
                  <Form.Group>
                    <label>
                      Member Type <span>*</span>
                    </label>
                    <Form.Control
                      className={errors.memberType ? `on-error` : ``}
                      as="select"
                      onChange={(e) => {
                        setTeamMember({
                          ...teamMember,
                          memberType: e.target.value,
                        });
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          memberType: "",
                        }));
                      }}
                      value={teamMember?.memberType}
                      disabled={modalType === 1}
                      required
                    >
                      <option value="-">Select member type</option>
                      {memberOptions &&
                        memberOptions.map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                    </Form.Control>
                    <span
                      className={errors && errors.memberType ? `` : `d-none`}
                    >
                      <label className="pl-1">
                        {errors && errors.memberType ? errors.memberType : ""}
                      </label>
                    </span>
                  </Form.Group>
                  <Form.Group>
                    <label>Facebook Url</label>
                    <Form.Control
                      placeholder="Enter facebook profile url..."
                      type="text"
                      name="facebook"
                      onChange={(e) =>
                        setTeamMember({
                          ...teamMember,
                          facebook: e.target.value,
                        })
                      }
                      value={teamMember.facebook}
                      disabled={modalType === 1}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>X Url</label>
                    <Form.Control
                      placeholder="Enter x profile url..."
                      type="text"
                      name="x"
                      onChange={(e) =>
                        setTeamMember({ ...teamMember, x: e.target.value })
                      }
                      value={teamMember.x}
                      disabled={modalType === 1}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>LinkedIn Url</label>
                    <Form.Control
                      placeholder="Enter linkedIn profile url..."
                      type="text"
                      name="linkedIn"
                      onChange={(e) =>
                        setTeamMember({
                          ...teamMember,
                          linkedIn: e.target.value,
                        })
                      }
                      value={teamMember.linkedIn}
                      disabled={modalType === 1}
                    />
                  </Form.Group>
                  <FormGroup>
                    <label>Status</label>
                    <div className="d-flex align-items-center">
                      <label className="right-label-radio mr-3 mb-2">
                        Active
                        <input
                          name="isActive"
                          disabled={modalType === 1}
                          type="radio"
                          checked={teamMember.isActive}
                          value={teamMember.isActive}
                          onChange={(e) =>
                            setTeamMember({ ...teamMember, isActive: true })
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      <label className="right-label-radio mr-3 mb-2">
                        Inactive
                        <input
                          name="isActive"
                          disabled={modalType === 1}
                          type="radio"
                          checked={!teamMember.isActive}
                          value={!teamMember.isActive}
                          onChange={(e) =>
                            setTeamMember({ ...teamMember, isActive: false })
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </FormGroup>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button className="outline-button" onClick={modalCloseHandler}>
                  Close
                </Button>
                {(modalType === 2 || modalType === 3) && (
                  <Button className="btn-filled" onClick={submit} disabled={isCreatingMember || isUpdatingMember}>
                    {" "}
                    Submit
                  </Button>
                )}
              </Modal.Footer>
            </Modal>
          )}
        </Container>
    </>
  );
};

export default TeamMembersListing;
